function hasSameOrigin(url) {
  return new URL(url, window.location.href).origin === window.location.origin;
}
export function setVersionOnEntriesFile(_ref) {
  let {
    url,
    version
  } = _ref;
  if (!version) {
    return url;
  }
  if (hasSameOrigin(url)) {
    /**
     * The URL is a pathname only and is part of the legacy infrastructure.
     * It looks like this: /assets/exo/some-name/assets-no-cache/remoteEntry.js
     */

    const urlObj = new URL(url, window.location.origin);
    const pathnameParts = urlObj.pathname.split('/');
    pathnameParts.splice(3, 0, version);
    return pathnameParts.join('/');
  }
  const urlObj = new URL(url);
  const pathnameParts = urlObj.pathname.split('/');
  pathnameParts.splice(1, 0, version);
  urlObj.pathname = pathnameParts.join('/');
  return urlObj.toString();
}
//# sourceMappingURL=setVersionOnEntriesFile.js.map